import { Component, Input, OnInit } from '@angular/core';
import { NotificationService } from '../../services/notification.service';
import { SharedHttpService } from './../../services/shared-http.service';
import { LookupService } from 'src/app/shared/services/lookup.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { CaseService } from '../../services/case.service';

@Component({
  selector: 'app-case-acceptance',
  templateUrl: './case-acceptance.component.html',
  styleUrls: ['./case-acceptance.component.scss']
})
export class CaseAcceptanceComponent implements OnInit {
  @Input() delegationId: any;
  eCaseId:any;
  decisionsArr:any=[];
  decisionId:any;
  description:any;
  tabid: any;


  constructor(private caseService: CaseService, private sharedService:SharedHttpService, private toastr : NotificationService, private lookupService:LookupService, public router: ActivatedRoute,private route:Router) { }
      @Input() loadDataFP: Observable<any>;
    ngOnInit(): void {
  
        this.loadDataFP.subscribe((data) => {
            setTimeout(() => {
                this.loadData();
            }, 100);

        });

    switch(this.delegationId) {
      case 4:
        this.decisionsArr = this.lookupService.getLockup('casereportreviewstatus');
        break;

      case 5:
        this.decisionsArr = this.lookupService.getLockup('casereportsignstatus');
        break;
      default:
    }

  }
  
  loadData(){
    this.eCaseId = this.router.snapshot.params['id'];
    this.tabid = this.router.snapshot.params['tabid'];

      this.decisionsArr = [];

      this.decisionsArr = this.lookupService.getLockup('casereviewstatus');
      //switch (this.delegationId) {
      //    case 1:
      //        this.decisionsArr = this.lookupService.getLockup('casereviewstatus');
      //          //  .filter(a => a.more === this.caseService.case.caseTypeId.toString());
 
      //        break;
      //    case 2:
      //        this.decisionsArr = this.lookupService.getLockup('caseinspectionreviewstatus')
      //            .filter(a => a.more === this.caseService.case.caseTypeId.toString());
      //        break;

      //    case 3:
      //        this.decisionsArr = this.lookupService.getLockup('casecallsstatus')
      //            .filter(a => a.more === this.caseService.case.caseTypeId.toString());
      //        break;
      //    case 4:
      //        this.decisionsArr = this.lookupService.getLockup('casereportreviewstatus')
      //            .filter(a => a.more === this.caseService.case.caseTypeId.toString());
      //        break;

      //    case 5:
      //        this.decisionsArr = this.lookupService.getLockup('casereportsignstatus')
      //            .filter(a => a.more === this.caseService.case.caseTypeId.toString());
      //        break;
      //    default:
      //}
  }
  delegationSubmit(){
    let obj ={
      "eCaseId": this.eCaseId,
      "isNext": false,
      "isPrevious": false,
      "selectedDecsionId": this.decisionId,
      "delegationId": this.delegationId,
      "decsionNotes": this.description
    }
    this.sharedService.post(`api/Case/Delegate`,obj).subscribe(res=>{
      if(res.isSucess === true){
        this.decisionId = undefined;
        this.description = undefined;

        this.sharedService.TranslateKey('CaseSendSuccessfully').subscribe(value=>{
          this.toastr.showSuccess(value,'');
            if (this.caseService.case.caseTypeId == 1) {
this.route.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
          this.route.navigate([`concealment/cases/details/${this.eCaseId}/${this.tabid}`]);
        }); 
            }
            else {
                this.route.navigateByUrl('/refresh', { skipLocationChange: true }).then(() => {
                    this.route.navigate([`fraud/cases/details/${this.eCaseId}/${this.tabid}`]);
                }); 
            }


        });
        
      }else{
        this.toastr.showError(res.message,'');
      }
    })
  }

}
